import { IProductDescription } from '../dataModels/ProductModels';
import * as style from './style.css';
import TextSplitter from '../../../components/textSplitter/TextSplitter';
import React = require('react');

interface IProps {
    uriBuild: (path: string) => string;
    descriptions: IProductDescription[];
}
interface IState {
}

export default class ModelDescriptions extends React.Component<IProps, IState> {
    render() {
        return (
            <div className={style.descriptionsWrapper}>
                <div className={style.descriptions}>
                    {this.props.descriptions.map(d => this.description(d))}
                </div>
            </div>
        );
    }

    description(descr: IProductDescription): any {
        return <div key={descr.id} className={style.description}>
            {descr.title &&
                <div className={style.label}>
                    {descr.title}
                </div>
            }
            <div className={style.content} >
                <TextSplitter text={descr.text} />
            </div>
        </div>;
    }
}
